export const getChatSettingsLink = (hostname: string, projectKey: string, isSimplified: boolean) =>
	`https://${hostname}/jira/servicedesk/projects/${projectKey}/settings${
		isSimplified ? '/channels' : ''
	}/chat?placement=channelsConfigure`;
